import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useDiwaliCampaign } from "@/hooks/useDiwaliCampaign";

const DISMISS_KEY = "diwali_banner_dismissed_2026";

/**
 * Slim dismissible notice rendered under the header on every public page
 * while the Diwali campaign is active. A normal content bar, not an edge
 * stripe. Self-contained - hides itself once the campaign ends.
 */
export default function DiwaliBanner() {
  const { status } = useDiwaliCampaign();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === "1";
    } catch {
      return false;
    }
  });

  if (!status?.active || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch {
      // localStorage can be unavailable (private mode) - dismissal just won't persist
    }
  };

  return (
    <div className="w-full bg-amtm-teal text-white" data-testid="diwali-banner">
      <div className="max-w-6xl mx-auto px-10 py-2.5 flex items-center justify-center relative text-sm">
        <Link to="/diwali" className="font-medium hover:underline text-center" data-testid="diwali-banner-link">
          Diwali for the whole AMTM family. Send a festive gift
        </Link>
        <button
          type="button"
          onClick={handleDismiss}
          data-testid="diwali-banner-dismiss"
          aria-label="Dismiss"
          className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
